import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/studies_analytics_event.py
export const STUDIES_ANALYTICS_ACTIONS = {
  // Write actions
  CREATED_STUDY: {
    module: ANALYTICS_MODULE.STUDIES,
    action: 'created_study',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_STUDY_PHASE: {
    module: ANALYTICS_MODULE.STUDIES,
    action: 'updated_study_phase',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ARCHIVED_STUDIES: {
    module: ANALYTICS_MODULE.STUDIES,
    action: 'archived_studies',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_PROCEDURE_RUN_PLAN: {
    module: ANALYTICS_MODULE.STUDIES,
    action: 'created_procedure_run_plan',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_PROCEDURE_RUN_PLAN: {
    module: ANALYTICS_MODULE.STUDIES,
    action: 'updated_procedure_run_plan',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ARCHIVED_STUDY_SCHEMAS: {
    module: ANALYTICS_MODULE.STUDIES,
    action: 'archived_study_schemas',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UNARCHIVED_STUDY_SCHEMAS: {
    module: ANALYTICS_MODULE.STUDIES,
    action: 'unarchived_study_schemas',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_STUDY_SCHEMA: {
    module: ANALYTICS_MODULE.STUDIES,
    action: 'updated_study_schema',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  WARNING_SHOWN_INVALID_CONDITIONS: {
    module: ANALYTICS_MODULE.STUDIES,
    action: 'warning_shown_invalid_conditions',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_OR_UPDATED_STUDY_NOTIFICATION_SCHEDULES: {
    module: ANALYTICS_MODULE.STUDIES,
    action: 'created_or_updated_study_notification_schedules',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPTED_IN_TO_FLOWCHART_PROCEDURE_RUN_DESIGN: {
    module: ANALYTICS_MODULE.STUDIES,
    action: 'opted_in_flowchart_procedure_run_design',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPTED_OUT_OF_FLOWCHART_PROCEDURE_RUN_DESIGN: {
    module: ANALYTICS_MODULE.STUDIES,
    action: 'opted_out_flowchart_procedure_run_design',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  // Studyable actions
  ADDED_ITEMS_TO_STUDIES: {
    module: ANALYTICS_MODULE.STUDIES,
    action: 'added_items_to_studies',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  // Read actions
  CLICKED_AUTO_MAP_CONDITIONS: {
    module: ANALYTICS_MODULE.STUDIES,
    action: 'clicked_auto_map_conditions',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RAN_LLM_COMPLETION: {
    module: ANALYTICS_MODULE.STUDIES,
    action: 'ran_llm_completion',
    actionCategory: ACTION_CATEGORY.READ,
  },
};
